exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkout-btn[data-v-34816a10] {\n  width: 160px;\n  height: 36px;\n  border-radius: 4px;\n  border: solid 1px #e5e5e5;\n  color: #ffffff;\n}\n.price-btn[data-v-34816a10] {\n  width: 53px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #ffffff;\n}\n.price-inp[data-v-34816a10] {\n  width: 152px;\n  height: 36px;\n  /* border-radius: 4px; */\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #e5e5e5;\n}\n.calculate-price-btn[data-v-34816a10] {\n  width: 36px;\n  height: 36px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #1b0000;\n}\n.input[data-v-34816a10]::-webkit-outer-spin-button,\n.input[data-v-34816a10]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34816a10","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/check-out/CheckoutByCash.vue
// module id = 467
// module chunks = 1